<template>
  <div class="func-btn-item" @click="handleClick">
    <div class="btn-icon">
      <i :class="item.icon"></i>
    </div>
    <div class="btn-text">
      <div class="btn-name">{{ item.name }}</div>
      <div v-if="item.desc" class="btn-desc">{{ item.desc }}</div>
    </div>
    <!-- 开关组件，针对agent/自动模式 -->
    <div v-if="item.isSwitch" class="switch-wrap">
      <div class="switch" :class="{active: item.value}"></div>
    </div>
    <span v-if="item.badge" class="badge">{{ item.badge }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('click-func', this.item)
    }
  }
}
</script>

<style scoped>
.func-btn-item {
  background: #f5f7fa;
  border-radius: 24px;
  padding: 12px 18px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}

.func-btn-item:hover {
  background: #eaf6ff;
  border-color: #ccebfa;
  transform: translateY(-1px);
}

.btn-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #2794e8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}

.btn-text {
  flex: 1;
}

.btn-name {
  font-size: 15px;
  font-weight: 500;
  color: #222;
  line-height: 1.3;
}
.btn-desc {
  font-size: 12px;
  color:#888;
  margin-top:2px;
}

/*开关样式*/
.switch-wrap {
  flex-shrink:0;
}
.switch {
  width:40px;
  height:22px;
  border-radius:20px;
  background:#cccccc;
  position:relative;
  transition:0.25s;
}
.switch::after{
  content:'';
  width:18px;
  height:18px;
  background:#fff;
  border-radius:50%;
  position:absolute;
  top:2px;
  left:2px;
  transition:0.25s;
}
.switch.active {
  background:#2794e8;
}
.switch.active::after{
  left:20px;
}

.badge {
  position: absolute;
  top: 8px;
  right: 12px;
  background: #ff4d4f;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 12px;
  line-height: 1;
}
</style>
